import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, Linkedin } from "lucide-react";
import logo from "@/assets/logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-card border-t border-border" role="contentinfo">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src={logo} 
              alt="Bianchim Business" 
              className="h-24 w-auto"
            />
            <p className="text-sm text-white/90">
              Gerando grandes resultados! Transformando equipes comerciais com inteligência artificial e gamificação.
            </p>
            <a
              href="https://www.instagram.com/junior.bianchim/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-white/90 hover:text-primary transition-colors"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5" aria-hidden="true" />
              @junior.bianchim
            </a>
            <a
              href="https://www.linkedin.com/in/junior-bianchim-017a64184/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-primary font-semibold hover:text-primary/80 transition-colors"
              aria-label="LinkedIn do Junior Bianchim"
            >
              <Linkedin className="w-5 h-5" aria-hidden="true" />
              Junior Bianchim — CEO
            </a>
            <a
              href="https://www.linkedin.com/company/bianchimbusiness/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-white/90 hover:text-primary transition-colors"
              aria-label="LinkedIn da Bianchim Business"
            >
              <Linkedin className="w-5 h-5" aria-hidden="true" />
              Bianchim Business
            </a>
          </div>

          {/* Quick Links */}
          <nav className="space-y-4" aria-label="Links rápidos">
            <h4 className="font-semibold text-foreground">Atalhos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/auth" className="text-sm text-white/90 hover:text-primary transition-colors">
                  Criar Conta
                </Link>
              </li>
              <li>
                <Link to="/auth" className="text-sm text-white/90 hover:text-primary transition-colors">
                  Fazer Login
                </Link>
              </li>
              <li>
                <Link to="/#pricing" className="text-sm text-white/90 hover:text-primary transition-colors">
                  Planos e Preços
                </Link>
              </li>
              <li>
                <Link to="/#blog" className="text-sm text-white/90 hover:text-primary transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/calculadora-roi" className="text-sm text-white/90 hover:text-primary transition-colors">
                  Calculadora de ROI
                </Link>
              </li>
              <li>
                <Link to="/imersao-lider" className="text-sm text-white/90 hover:text-primary transition-colors">
                  Imersão Líder
                </Link>
              </li>
              <li>
                <Link to="/vendaspro360_docontato_afidelizacao" className="text-sm text-white/90 hover:text-primary transition-colors">
                  Vendas Pro 360º
                </Link>
              </li>
            </ul>
          </nav>

          {/* Legal */}
          <nav className="space-y-4" aria-label="Links legais">
            <h4 className="font-semibold text-foreground">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/politica-privacidade" className="text-sm text-white/90 hover:text-primary transition-colors">
                  Política de Privacidade
                </Link>
              </li>
              <li>
                <Link to="/termos-uso" className="text-sm text-white/90 hover:text-primary transition-colors">
                  Termos de Uso
                </Link>
              </li>
              <li>
                <Link to="/politica-reembolso" className="text-sm text-white/90 hover:text-primary transition-colors">
                  Política de Reembolso
                </Link>
              </li>
              <li>
                <Link to="/politica-cookies" className="text-sm text-white/90 hover:text-primary transition-colors">
                  Política de Cookies
                </Link>
              </li>
              <li>
                <Link to="/lgpd" className="text-sm text-white/90 hover:text-primary transition-colors">
                  LGPD
                </Link>
              </li>
            </ul>
          </nav>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="font-semibold text-foreground">Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-white/90">
                <Mail className="w-4 h-4 text-primary flex-shrink-0" aria-hidden="true" />
                <a href="mailto:junior@bianchimbusiness.com.br" className="hover:text-primary transition-colors break-all">
                  junior@bianchimbusiness.com.br
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm text-white/90">
                <Phone className="w-4 h-4 text-primary flex-shrink-0" aria-hidden="true" />
                <a 
                  href="https://wa.me/5516981960018" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-primary transition-colors"
                >
                  +55 (16) 98196-0018
                </a>
              </li>
              <li className="flex items-start gap-2 text-sm text-white/90">
                <MapPin className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" aria-hidden="true" />
                <span>
                  Rua Danilo Micalli, 50<br />
                  Santa Felícia<br />
                  São Carlos – SP<br />
                  CEP: 13563-264
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-border py-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/90">
              © {currentYear} Bianchim Business. Todos os direitos reservados.
            </p>
            <p className="text-sm text-white/90">
              Empresa com tecnologia acelerada pela{" "}
              <a 
                href="https://shinier.com.br" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary hover:underline font-medium"
              >
                Shinier
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
